var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.$style.wrapper},_vm._l((_vm.competitors),function(competitor){return _c('li',{key:competitor.id},[_vm._v(" "+_vm._s(competitor.name)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }